import * as TagAPI from "api/TagAPI";
import * as ModelGroupAPI from "api/ModelGroupAPI";

import * as accountsReducer from "containers/Accounts/reducer";
import * as globalReducer from "containers/App/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";

import { AibleClientFactory } from "client/aible/factory";

import { isEnabled } from "utils/featureFlags";

const UPDATE_FIELD = "modelGarden/UPDATE_FIELD";

const initialState = {
  models: {}
};

function modelGardenReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: {
          ...action.data
        }
      };
    default:
      return state;
  }
}

/* Selectors */
export function getIsModelSplits() {
  return isEnabled("model-splits");
}

export function getBase(state) {
  return state.modelGarden;
}

export function getModels(state) {
  const modelGarden = getBase(state);

  return modelGarden?.models;
}

/* Actions */
export function updateModels(models) {
  return {
    type: UPDATE_FIELD,
    key: "models",
    data: models
  };
}

export function fetchModelGarden() {
  return async (dispatch, getState) => {
    // Don't fetch if flag is disabled
    if (isEnabled("model-garden") !== true) {
      return Promise.resolve();
    }

    const accountId = accountsReducer.getSelectedAccountId(getState());

    console.log("fetching model gardnemn", accountId);

    const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);

    try {
      const completion_modelGarden = await factory.getCompletionClient().getModelGarden();

      console.log("model gardsen fetch?", completion_modelGarden);

      dispatch(updateModels(completion_modelGarden));
    } catch (e) {
      console.log("model garden fetch error", e);
    }
  };
}

export default modelGardenReducer;
